import { createStore } from 'zustand'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'

import { AuctionListStore, AuctionListStoreOptions } from './interface'

export const createAuctionListStore = ({
  tableRef,
  previewRef,
  bidMemberListRef
}: AuctionListStoreOptions) =>
  createStore<AuctionListStore>((set, get) => ({
    tableRef,
    previewRef,
    currentAuction: undefined,
    setCurrentAuction(value) {
      set({ currentAuction: value })
    },
    detailFormMode: FormMode.READ,
    setDetailFormMode(mode) {
      set({ detailFormMode: mode })
    },
    detailFormVisible: false,
    toggleDetailFormVisible(visible) {
      const { detailFormVisible, setDetailFormMode, setCurrentAuction } = get()
      const newVisible = visible ?? !detailFormVisible

      set({ detailFormVisible: newVisible })

      if (!newVisible) {
        setDetailFormMode(FormMode.READ)
        setCurrentAuction(undefined)
      }
    },
    bidMemberListRef,
    bidMemberListModalVisible: false,
    toggleBidMemberListModalVisible(visible) {
      set({
        bidMemberListModalVisible: visible ?? !get().bidMemberListModalVisible
      })
    },
    bidRecordListModalVisible: false,
    toggleBidRecordListModalVisible(visible) {
      set({
        bidRecordListModalVisible: visible ?? !get().bidRecordListModalVisible
      })
    },
    haltFormVisible: false,
    toggleHaltFormVisible(visible) {
      set({ haltFormVisible: visible ?? !get().haltFormVisible })
    },
    dealNoticeBatchDownloadModalVisible: false,
    toggleDealNoticeBatchDownloadModalVisible(visible) {
      set(state => ({
        dealNoticeBatchDownloadModalVisible:
          visible ?? !state.dealNoticeBatchDownloadModalVisible
      }))
    },
    abortiveExplainFormMode: FormMode.READ,
    setAbortiveExplainFormMode(mode) {
      set({ abortiveExplainFormMode: mode })
    },
    abortiveExplainVisible: false,
    toggleAbortiveExplainVisible(visible) {
      const {
        abortiveExplainVisible,
        setAbortiveExplainFormMode,
        setCurrentAuction
      } = get()
      const newVisible = visible ?? !abortiveExplainVisible

      set({ abortiveExplainVisible: newVisible })

      if (!newVisible) {
        setAbortiveExplainFormMode(FormMode.READ)
        setCurrentAuction(undefined)
      }
    }
  }))
